export default __webpack_public_path__ + "static/media/engageIcon1.5b770687.svg";